class Users{

    constructor(apiService=null){
        this.obj_name = 'users'
        this.apiService = apiService != null ? apiService : null; // 將 ApiService 實例儲存為屬性

        this.userData = localStorage.getItem('wildone_account') ? this.getUserData() : null
        this.userPermission = localStorage.getItem('wildone_per') ? this.getUserPermission().role_permission_json : null
    }
    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            { condition: formData.role_name.trim() === '', message: '請輸入角色名稱' },
            { condition: formData.group_name.trim() === '' , message: '請輸入角色群組' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }   

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    // 送出前檢查表單填寫格式
    checkAccountCreateFromModel(formData) {
        const validations = [
            { condition: formData.email.trim() === '', message: '請輸入Email做為帳號' },
            { condition: !this.isValidEmail(formData.email.trim()), message: '請輸入格式Email' },
            { condition: formData.password.trim() === '' , message: '請輸入密碼' },
            { condition: formData.rePassword.trim() === '' , message: '請再次輸入密碼' },
            { condition: formData.rePassword.trim() !== formData.password.trim() , message: '密碼與再次輸入密碼需相符' },
            { condition: formData.name.trim() === '' , message: '請輸入帳號姓名' },
            { condition: formData.department_sn.trim() === '' , message: '請選擇所屬單位' },
            { condition: formData.role_id === -1 , message: '請選擇角色' },
            // { condition: formData.img_src === '' , message: '請上傳你的頭像' },
            { condition: formData.is_enable_controlledDrugs === true && formData.controlledDrugs_no == '' , message: '請輸入管制藥證' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }   
    //登入事件處理
    loginSuccessHandle(token,per){
        this.apiService.loginSuccessHandle(token,per)
        this.userData = this.getUserData()
        this.userPermission = this.getUserPermission().role_permission_json
    }
    //取得使用者資料
    getUserData(){
        const userData = localStorage.getItem('wildone_account') ? localStorage.getItem('wildone_account') : null
        if ( !userData ){
            return null
        }
        return JSON.parse(this.apiService.AES_ECB_DECRYPT(userData))
    }
    getUserPermission(){
        const userPermission = localStorage.getItem('wildone_per') ? localStorage.getItem('wildone_per') : null
        if ( !userPermission ){
            return null
        }
        return JSON.parse(this.apiService.AES_ECB_DECRYPT(userPermission))
    }
    //檢查主權限
    checkPermission(key){
        const permission = this.userPermission != null ? this.userPermission.find(item=>item.key===key) : null
        // const permission = this.test_permissions != null ? this.test_permissions.find(item=>item.key===key) : null
        return permission ? permission.status : false
    }
    //檢查子權限
    checkSubPermission(key,subKey){
        const permission = this.userPermission != null ? this.userPermission.find(item=>item.key===key) : null
        // const permission = this.test_permissions != null ? this.test_permissions.find(item=>item.key===key) : null
        // console.log(`permission=` , permission)
        if ( ( permission ? permission.status : false ) ){
            const subPermission = permission.sub.find(item=>item.key===subKey)
            return subPermission ? subPermission.status : false
        }
        return false
    }

    //帳號 | 101取得主治醫師
    async getAccountMainDoctor(parameter=null){
        return this.callApi('get', 'getAccountMainDoctor', parameter);
    }
    //帳號 | 102新增角色
    async addRole(parameter, progressEvent = null){
        return this.callApi('post', 'addRole', parameter , progressEvent);
    }
    //帳號 | 103更新角色
    async updRole(parameter, progressEvent = null){
        return this.callApi('post', 'updRole', parameter , progressEvent);
    }
    //帳號 | 104取得角色詳細資料
    async getRoleDetailByRoleId(parameter=null){
        return this.callApi('get', 'getRoleDetailByRoleId', parameter);
    }
    //帳號 | 105取得角色列表
    async getRoleByKeywordWithPage(parameter=null){
        return this.callApi('get', 'getRoleByKeywordWithPage', parameter);
    }
    //帳號 | 106新增帳號
    async addAccount(parameter, progressEvent = null){
        return this.callApi('post', 'addAccount', parameter , progressEvent);
    }
    //帳號 | 107更新帳號
    async updAccount(parameter, progressEvent = null){
        return this.callApi('post', 'updAccount', parameter , progressEvent);
    }
    //帳號 | 108取得帳號列表
    async getAccountByKeywordWithPage(parameter){
        return this.callApi('get', 'getAccountByKeywordWithPage', parameter );
    }
    //帳號 | 109取得帳號詳細資料
    async getAccountDetailByAccountId(parameter){
        return this.callApi('get', 'getAccountDetailByAccountId', parameter);
    }
    //帳號 | 110更新密碼
    async updAccountPasswordByAccountId(parameter, progressEvent = null){
        return this.callApi('post', 'updAccountPasswordByAccountId', parameter , progressEvent);
    }
    //帳號 | 111登入
    async login(parameter, progressEvent = null){
        return this.callApi('post', 'login', parameter , progressEvent);
    }
    //帳號 | 112管理員更改密碼
    async updAccountPasswordByManager(parameter, progressEvent = null){
        return this.callApi('post', 'updAccountPasswordByManager', parameter , progressEvent);
    }
    //帳號 | 113取得行事曆
    async getCalendar(parameter){
        return this.callApi('get', 'getCalendar', parameter);
    }
    //處理新增權限項目 -- 預設關閉
    permissionItemsHandle(permissions){
        for (let i = 0; i < this.permissions.length; i++) {
            const permission = this.permissions[i];
            //檢查是否有缺少的主權線
            const permissionIndex = permissions.findIndex(item=>item.key == permission.key )
            if ( permissionIndex == -1 ){ //找不到代表要加入新的主功能權限
                permissions.push(permission)
            } else { //有找到該主要功能權限，接著檢查sub內的權限
                for (let n = 0; n < permission.sub.length; n++) {
                    const sub = permission.sub[n];
                    const subIndex = permissions[permissionIndex].sub.findIndex(item=>item.key == sub.key )
                    if ( subIndex == -1 ){
                        permissions[permissionIndex].sub.push(sub)
                    }
                }
            }
        }
        return permissions
    }

    permissions = [{
        key:'users',
        status:true,
        name:'帳號管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'changePassword',
            status:true,
            name:'管理員更改密碼'
        }]
    },{
        key:'role',
        status:true,
        name:'角色管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'ack',
        status:true,
        name:'受理單管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'medical',
        status:true,
        name:'病歷管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'ftm',
        status:true,
        name:'初步檢傷',sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'tm',
        status:true,
        name:'診療紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'pres',
        status:true,
        name:'開藥紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'care',
        status:true,
        name:'照養紀錄',
        sub:[{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'create-rec',
            status:true,
            name:'新增食譜'
        }]
    },{
        key:'surg',
        status:true,
        name:'手術/麻醉紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'exam',
        status:true,
        name:'檢驗紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'diss',
        status:true,
        name:'解剖管理',
        sub:[{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'examManager',
        status:true,
        name:'檢驗管理',
        sub:[{
            key:'create',
            status:true,
            name:'送檢申請'
        }]
    },{
        key:'ft',
        status:true,
        name:'野放管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增野訓計畫'
        },{
            key:'update',
            status:true,
            name:'編輯野訓計畫'
        },{
            key:'create-assessment',
            status:true,
            name:'建立野放評估'
        },{
            key:'create-form',
            status:true,
            name:'新增野放評估表單'
        },{
            key:'update-form',
            status:true,
            name:'編輯野放評估表單'
        },{
            key:'tracking',
            status:true,
            name:'野訓追蹤'
        }]
    },{
        key:'inv',
        status:true,
        name:'庫存管理',
        sub:[{
            key:'create-type',
            status:true,
            name:'新增品項類別'
        },{
            key:'update-type',
            status:true,
            name:'編輯品項類別'
        },{
            key:'create-item',
            status:true,
            name:'新增品項'
        },{
            key:'update-item',
            status:true,
            name:'編輯品項'
        },{
            key:'create-po',
            status:true,
            name:'新增採購單'
        },{
            key:'inStock',
            status:true,
            name:'入庫作業'
        },{
            key:'outStock',
            status:true,
            name:'出庫作業'
        },{
            key:'stock-fix',
            status:true,
            name:'庫存異動'
        }]
    },{
        key:'parameters',
        status:true,
        name:'參數管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'mis',
        status:true,
        name:'任務管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'typeSurvey',
        status:true,
        name:'型質測量管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'create-form',
            status:true,
            name:'新增型質測量表單'
        },{
            key:'update-form',
            status:true,
            name:'編輯型質測量表單'
        }]
    },{
        key:'species',
        status:true,
        name:'物種管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'schedule',
        status:true,
        name:'班表管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯所有人員'
        },{
            key:'update-self',
            status:true,
            name:'編輯自己'
        }]
    },{
        key:'vendor',
        status:true,
        name:'廠商管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    }]

    test_permissions = [{
        key:'users',
        status:true,
        name:'帳號管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'changePassword',
            status:true,
            name:'管理員更改密碼'
        }]
    },{
        key:'role',
        status:true,
        name:'角色管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'ack',
        status:true,
        name:'受理單管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'medical',
        status:true,
        name:'病歷管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'ftm',
        status:true,
        name:'初步檢傷',sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'tm',
        status:true,
        name:'診療紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'pres',
        status:true,
        name:'開藥紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'care',
        status:true,
        name:'照養紀錄',
        sub:[{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'create-rec',
            status:true,
            name:'新增食譜'
        }]
    },{
        key:'surg',
        status:true,
        name:'手術/麻醉紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'exam',
        status:true,
        name:'檢驗紀錄',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:false,
            name:'編輯'
        }]
    },{
        key:'diss',
        status:true,
        name:'解剖管理',
        sub:[{
            key:'update',
            status:false,
            name:'編輯'
        }]
    },{
        key:'examManager',
        status:true,
        name:'檢驗管理',
        sub:[{
            key:'create',
            status:true,
            name:'送檢申請'
        }]
    },{
        key:'ft',
        status:true,
        name:'野放管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增野訓計畫'
        },{
            key:'update',
            status:true,
            name:'編輯野訓計畫'
        },{
            key:'create-assessment',
            status:true,
            name:'建立野放評估'
        },{
            key:'create-form',
            status:true,
            name:'新增野放評估表單'
        },{
            key:'update-form',
            status:true,
            name:'編輯野放評估表單'
        },{
            key:'tracking',
            status:true,
            name:'野訓追蹤'
        }]
    },{
        key:'inv',
        status:true,
        name:'庫存管理',
        sub:[{
            key:'create-type',
            status:true,
            name:'新增品項類別'
        },{
            key:'update-type',
            status:true,
            name:'編輯品項類別'
        },{
            key:'create-item',
            status:true,
            name:'新增品項'
        },{
            key:'update-item',
            status:true,
            name:'編輯品項'
        },{
            key:'create-po',
            status:true,
            name:'新增採購單'
        },{
            key:'inStock',
            status:true,
            name:'入庫作業'
        },{
            key:'outStock',
            status:false,
            name:'出庫作業'
        },{
            key:'stock-fix',
            status:true,
            name:'庫存異動'
        }]
    },{
        key:'parameters',
        status:true,
        name:'參數管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'mis',
        status:true,
        name:'任務管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:false,
            name:'編輯'
        }]
    },{
        key:'typeSurvey',
        status:true,
        name:'型質測量管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        },{
            key:'create-form',
            status:true,
            name:'新增型質測量表單'
        },{
            key:'update-form',
            status:true,
            name:'編輯型質測量表單'
        }]
    },{
        key:'species',
        status:true,
        name:'物種管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    },{
        key:'schedule',
        status:true,
        name:'班表管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯所有人員'
        },{
            key:'update-self',
            status:true,
            name:'編輯自己'
        }]
    },{
        key:'vendor',
        status:true,
        name:'廠商管理',
        sub:[{
            key:'create',
            status:true,
            name:'新增'
        },{
            key:'update',
            status:true,
            name:'編輯'
        }]
    }]
}

export default Users;